import * as React from 'react'

const SvgBb8 = (props) => {
  const { color } = props
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 33 54'
      {...props}
    >
      <path
        d='M16.61 12.94c-.74 0-1.34.61-1.34 1.35 0 .74.6 1.35 1.34 1.35.74 0 1.34-.6 1.34-1.35 0-.75-.6-1.35-1.34-1.35m0 4.49c-1.72 0-3.12-1.41-3.12-3.14 0-1.73 1.4-3.14 3.12-3.14 1.72 0 3.12 1.41 3.12 3.14 0 1.73-1.4 3.14-3.12 3.14m6.03-.14a1.093 1.093 0 0 1-1.09 1.09 1.093 1.093 0 0 1-.771-1.861 1.093 1.093 0 0 1 1.861.771M9.61 22.74c-5.11 2.61-8.27 7.79-8.27 13.55 0 8.38 6.78 15.19 15.1 15.19s15.1-6.82 15.1-15.19c0-5.76-3.17-10.94-8.27-13.55H9.61Zm6.83 30.09C7.38 52.83 0 45.41 0 36.29c0-6.33 3.51-12.01 9.16-14.82l.14-.07h14.29l.14.07c5.65 2.81 9.16 8.49 9.16 14.82 0 9.12-7.38 16.54-16.44 16.54Z'
        fill={color || '#FFF'}
      />
      <path
        d='m20.55 36.62-.8 2.09 3.88 1.96c-1.82 2.99-5.32 4.57-8.76 3.93l1.14-4.22-2.08-.8-1.95 3.91C9 41.66 7.44 38.13 8.07 34.68l4.19 1.15.8-2.09-3.88-1.96c1.82-2.99 5.32-4.57 8.76-3.93l-1.14 4.22 2.08.8 1.95-3.91c2.98 1.83 4.54 5.36 3.9 8.81l-4.19-1.15Zm-4.13-10.24c-5.41 0-9.79 4.41-9.79 9.85 0 5.44 4.38 9.85 9.79 9.85 5.41 0 9.79-4.41 9.79-9.85 0-5.44-4.38-9.85-9.79-9.85ZM18.94 9.21a.668.668 0 0 1-.67-.67V2.85a.67.67 0 0 1 1.34 0v5.69a.673.673 0 0 1-.67.67'
        fill={color || '#FFF'}
      />
      <path
        d='M8.1 20.65h16.96l.91-2.07c-.04-5.17-4.24-9.37-9.39-9.37s-9.35 4.19-9.39 9.37l.92 2.07Zm17.83 1.34H7.23l-1.38-3.13v-.2c0-5.95 4.81-10.79 10.73-10.79 5.92 0 10.73 4.84 10.73 10.79v.2l-1.38 3.13Z'
        fill={color || '#FFF'}
      />
      <path
        d='M15.03 8.88a.673.673 0 0 1-.67-.67V6.13a.67.67 0 0 1 1.34 0v2.08a.673.673 0 0 1-.67.67'
        fill={color || '#FFF'}
      />
    </svg>
  )
}

export default SvgBb8
